//include 11
// Accessible date range picker based on the <wc-datepicker> web component.
// The component itself is loaded as ES module (see page.includeJSFooterlibs.wcDatepicker).
// @see https://ticket.pixelpoint.at/issues/45703
// @see https://sqrrl.github.io/wc-datepicker
jQuery(function () {
    const PICKER_TAG = "wc-datepicker";
    const DISPLAY_FORMAT = "DD.MM.YYYY";
    const ISO_FORMAT = "YYYY-MM-DD";
    const VIEWPORT_GAP = 8;
    let instanceCounter = 0;

    const PICKER_LABELS = {
        de: {
            clearButton: "Auswahl löschen",
            dateDeselected: "abgewählt",
            dateSelected: "ausgewählt",
            datesSelected: "{count} Tage ausgewählt",
            monthSelect: "Monat auswählen",
            nextMonthButton: "Nächster Monat",
            nextYearButton: "Nächstes Jahr",
            picker: "Datum auswählen",
            previousMonthButton: "Vorheriger Monat",
            previousYearButton: "Vorheriges Jahr",
            todayButton: "Heute anzeigen",
            yearSelect: "Jahr auswählen"
        },
        en: {
            clearButton: "Clear selection",
            dateDeselected: "deselected",
            dateSelected: "selected",
            datesSelected: "{count} dates selected",
            monthSelect: "Select month",
            nextMonthButton: "Next month",
            nextYearButton: "Next year",
            picker: "Choose date",
            previousMonthButton: "Previous month",
            previousYearButton: "Previous year",
            todayButton: "Show today",
            yearSelect: "Select year"
        }
    };

    const getPickerLabels = (language) => {
        const labels = {};
        Object.keys(PICKER_LABELS[language]).forEach((key) => {
            labels[key] = window.ppt.translate(`datepicker.label.${key}`, PICKER_LABELS[language][key]);
        });
        return labels;
    };

    const setCalendarPosition = (calendarContainer) => {
        calendarContainer.removeClass("set-left set-right");
        const boundingRect = calendarContainer[0].getBoundingClientRect();
        if (boundingRect.left < 0) {
            calendarContainer.addClass("set-left");
        } else if (boundingRect.right > (window.innerWidth || document.documentElement.clientWidth)) {
            calendarContainer.addClass("set-right");
        }
    };

    // lightbox contents scroll (overflow: auto) and would cut the calendar off, position: fixed takes it out
    // of that scroll container (the transform of lity is removed in calendar.scss, otherwise it would be the
    // reference for position: fixed); it opens below the inputs if there is room, otherwise above
    const setFloatingCalendarPosition = (calendarContainer, anchor) => {
        const anchorRect = anchor[0].getBoundingClientRect();
        const boxRect = calendarContainer[0].getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = window.innerHeight;

        const spaceBelow = viewportHeight - anchorRect.bottom;
        const top = (spaceBelow >= boxRect.height || spaceBelow >= anchorRect.top) ? anchorRect.bottom : anchorRect.top - boxRect.height;
        calendarContainer.css({
            "position": "fixed",
            "top": `${Math.max(VIEWPORT_GAP, Math.min(top, viewportHeight - boxRect.height - VIEWPORT_GAP))}px`,
            "left": `${Math.max(VIEWPORT_GAP, Math.min(anchorRect.left, viewportWidth - boxRect.width - VIEWPORT_GAP))}px`,
            "right": "auto",
            "bottom": "auto"
        });
    };

    const resetFloatingCalendarPosition = (calendarContainer) => {
        calendarContainer.css({"position": "", "top": "", "left": "", "right": "", "bottom": ""});
    };

    // wc-datepicker compares dates by their local calendar day
    const toLocalDate = (date) => new Date(date.year(), date.month(), date.date());

    window.pixelpoint.ppComponents.calendar = function ($this) {
        const von = $this.find("input.von");
        const bis = $this.find("input.bis");

        if (von.length == 0 || bis.length == 0) return;

        const buttonClearDates = $this.find("i.clear-dates");
        const nameVon = von.attr("name");
        const nameBis = bis.attr("name");
        let isInitiallyDisabled = false;

        if ($this.is("[data-initially-disabled]")) {
            von.attr("name", "");
            bis.attr("name", "");
            isInitiallyDisabled = true;
        }

        const isPreFilled = $this.is("[data-prefilled]") || $this.hasClass("prefilled");
        const forceNextDay = !$this.is("[data-disable-forced-next-day]");
        const disableDefaultInput = $this.is("[data-disable-default-input]");

        const langObject = $("[data-language-obj]").data("language-obj");
        const language = (!!langObject && !!langObject.id) ? "en" : "de";

        const hoverTextSingle = $this.data("hover-text-single") || window.ppt.translate("night.singular", "Nacht");
        const hoverTextMultiple = $this.data("hover-text-multiple") || window.ppt.translate("night.plural", "Nächte");
        const bisTranslation = window.ppt.translate("to", "bis");

        // events allow the same day as start and end, bookings need at least one night
        const minNights = forceNextDay ? 1 : 0;

        const configuredStartDate = $this.data("start-date") ? moment($this.data("start-date"), DISPLAY_FORMAT) : null;
        const earliestStartDate = (configuredStartDate && configuredStartDate.isValid() && !configuredStartDate.isBefore(moment(), "day"))
            ? configuredStartDate
            : moment().startOf("day");

        const showOrHideClearDates = () => {
            buttonClearDates.toggleClass("hide", !von.val() && !bis.val());
        };

        if (!isPreFilled && !disableDefaultInput && !$this.is("[data-initially-empty]")) {
            if (!von.is(":disabled"))
                von.val(earliestStartDate.format(DISPLAY_FORMAT));
            if (!bis.is(":disabled"))
                bis.val(moment(earliestStartDate).add(minNights, "days").format(DISPLAY_FORMAT));
        }

        // reuse the id on re-initialisation (e.g. Merkliste), so document handlers and the mobile container are replaced
        let instanceId = $this.data("calendar-instance-id");
        if (!instanceId) {
            instanceId = `calendar-container-${++instanceCounter}`;
            $this.data("calendar-instance-id", instanceId);
        }
        const eventNamespace = instanceId.replace(/-/g, "");

        //***************************we prepare everything for the mobile version *******************/
        let appendContainerTo = $this;
        const isMobileLayer = window.pixelpoint.isMobile.isMobileWidth();
        if (isMobileLayer) {
            appendContainerTo = $("body").find(".calendar-layer");
            if (appendContainerTo.length == 0) {
                appendContainerTo = $('<div class="calendar-layer hide"></div>').appendTo("body");
                // keep clicks inside the layer away from the outside-click handler
                appendContainerTo.on("click", function (e) {
                    e.stopPropagation();
                });
            }
        }
        //***************************************************************************************** */

        let calendarContainer = $(`#${instanceId}`);
        if (calendarContainer.length == 0) {
            calendarContainer = $('<div class="calendar-container"></div>').appendTo(appendContainerTo);
        }

        calendarContainer
            .off()
            .empty()
            .removeClass("open first-date-selected")
            .attr({
                "id": instanceId,
                "role": "dialog",
                "aria-label": window.ppt.translate("datepicker.dialog.label", language === "en" ? "Choose travel dates" : "Reisezeitraum auswählen"),
                "hidden": true
            });
        if (isMobileLayer) {
            calendarContainer.attr("aria-modal", "true");
        }

        const closeButton = $('<button type="button" class="close"><i class="icon-close" aria-hidden="true"></i></button>')
            .attr("aria-label", window.ppt.translate("action.close", language === "en" ? "Close" : "Schließen"));
        const statusText = $('<p class="calendar-status" aria-live="polite"></p>');

        const picker = document.createElement(PICKER_TAG);
        picker.setAttribute("selection-mode", "range");
        picker.setAttribute("first-day-of-week", "1");
        picker.setAttribute("locale", language === "en" ? "en-GB" : "de-DE");
        picker.setAttribute("min-date", earliestStartDate.format(ISO_FORMAT));
        picker.setAttribute("start-date", earliestStartDate.format(ISO_FORMAT));

        calendarContainer.append(closeButton, statusText, picker);

        let saveButton = $();
        if (isMobileLayer) {
            saveButton = $('<button type="button" class="brandenbutton save-values"></button>')
                .text(window.ppt.translate("action.save", "Speichern"))
                .appendTo(calendarContainer);
        }

        von.add(bis).attr({
            "aria-haspopup": "dialog",
            "aria-controls": instanceId,
            "aria-expanded": "false"
        });

        let activeInput = von;
        // arrival date while the departure date is still missing
        let pendingStart = null;
        // true if the pending arrival date was picked by the user (not taken over from the input)
        let startPicked = false;

        const getPromptText = (input) => {
            if (input === von) {
                return window.ppt.translate("datepicker.select.nodates.error", 'Bitte wählen Sie ein "von" und "bis" Datum');
            }
            return window.ppt.translate("datepicker.select.noenddate.error", 'Bitte wählen Sie ein "bis" Datum');
        };

        const parseInputDate = (input) => {
            const date = moment(input.val(), DISPLAY_FORMAT, true);
            return date.isValid() ? date : null;
        };

        const markFirstDateSelected = (isSelected) => {
            $this.toggleClass("first-date-selected", isSelected);
            calendarContainer.toggleClass("first-date-selected", isSelected);
        };

        // the watcher of the component only runs on changes, resetting first always shows the month of the date
        const showMonthOf = (date) => {
            picker.startDate = undefined;
            picker.startDate = date.format(ISO_FORMAT);
        };

        const focusCurrentDate = () => {
            // the component renders asynchronously after value changes
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                    const currentDateCell = picker.querySelector('.wc-datepicker__date[tabindex="0"]');
                    if (currentDateCell) {
                        currentDateCell.focus();
                    }
                });
            });
        };

        const commitRange = (from, to) => {
            pendingStart = null;
            startPicked = false;
            von.val(from.format(DISPLAY_FORMAT));
            bis.val(to.format(DISPLAY_FORMAT));
            markFirstDateSelected(false);
            showOrHideClearDates();
            statusText.text(`${von.val()} ${bisTranslation} ${bis.val()}`);
        };

        const startRange = (date) => {
            pendingStart = date;
            startPicked = true;
            picker.value = [toLocalDate(date)];
            von.val(date.format(DISPLAY_FORMAT));
            markFirstDateSelected(true);
            statusText.text(getPromptText(bis));
        };

        const updateFloatingPosition = () => {
            if (calendarContainer.hasClass("open")) {
                setFloatingCalendarPosition(calendarContainer, $this);
            }
        };

        const openDatePicker = function (input) {
            if ($this.hasClass("disabled") || input.is(":disabled")) return;

            activeInput = input;
            const from = parseInputDate(von);
            const to = parseInputDate(bis);

            startPicked = false;
            // also discards the month the user navigated to last time
            showMonthOf(from || earliestStartDate);
            if (input === bis && from) {
                // only the departure date is left to choose
                pendingStart = from;
                picker.value = [toLocalDate(from)];
            } else {
                pendingStart = null;
                picker.value = (from && to) ? [toLocalDate(from), toLocalDate(to)] : undefined;
            }

            statusText.text(getPromptText(input));
            markFirstDateSelected(!!pendingStart);
            calendarContainer.removeAttr("hidden").addClass("open");
            $this.addClass("open");
            von.add(bis).attr("aria-expanded", "true");

            if (isMobileLayer) {
                appendContainerTo.removeClass("hide");
                // prevents iOS from zooming into the inputs
                von.add(bis).css({"font-size": "16px"});
            } else if ($this.closest(".lity").length > 0) {
                setFloatingCalendarPosition(calendarContainer, $this);
                // capture phase, so scrolling inside the lightbox content is noticed as well
                document.addEventListener("scroll", updateFloatingPosition, true);
                window.addEventListener("resize", updateFloatingPosition);
            } else {
                setCalendarPosition(calendarContainer);
            }

            focusCurrentDate();
        };

        const closeDatePicker = function (restoreFocus) {
            if (!calendarContainer.hasClass("open")) return;

            if (startPicked && pendingStart) {
                commitRange(pendingStart, moment(pendingStart).add(minNights, "days"));
            }
            pendingStart = null;
            startPicked = false;

            calendarContainer.attr("hidden", true).removeClass("open");
            document.removeEventListener("scroll", updateFloatingPosition, true);
            window.removeEventListener("resize", updateFloatingPosition);
            resetFloatingCalendarPosition(calendarContainer);
            markFirstDateSelected(false);
            $this.removeClass("open");
            von.add(bis).attr("aria-expanded", "false");

            if (isMobileLayer) {
                appendContainerTo.addClass("hide");
                von.add(bis).css({"font-size": ""});
            }

            if (restoreFocus) {
                activeInput.trigger("focus");
            }
        };

        // switching the month keeps the day of month, which may lie before the earliest date
        picker.addEventListener("changeMonth", function (event) {
            const date = moment({year: event.detail.year, month: event.detail.month - 1, day: event.detail.day});
            if (!date.isBefore(earliestStartDate, "day")) return;

            const hadDateFocus = !!document.activeElement && picker.contains(document.activeElement)
                && document.activeElement.matches(".wc-datepicker__date");
            // the component assigns the new date after emitting the event
            window.setTimeout(() => {
                showMonthOf(earliestStartDate);
                if (hadDateFocus) {
                    focusCurrentDate();
                }
            }, 0);
        });

        picker.addEventListener("selectDate", function (event) {
            const detail = Array.isArray(event.detail) ? event.detail : [];
            if (detail.length == 0) return;

            const first = moment(detail[0], ISO_FORMAT);
            const second = detail.length > 1 ? moment(detail[1], ISO_FORMAT) : null;

            // a new arrival date: first click, a click before the arrival date (the component swaps the dates then)
            // or a departure date too close to the arrival date
            if (!second || (pendingStart && !first.isSame(pendingStart, "day")) || second.diff(first, "days") < minNights) {
                startRange(first);
                return;
            }

            commitRange(first, second);
            if (!isMobileLayer) closeDatePicker(true);
        });

        // replaces the hover tooltip of the old picker and also works with keyboard navigation
        const showNightsHint = function (event) {
            if (!pendingStart || !event.target.closest) return;
            const dateCell = event.target.closest(".wc-datepicker__date[data-date]");
            if (!dateCell) return;
            const nights = moment(dateCell.getAttribute("data-date"), ISO_FORMAT).diff(pendingStart, "days");
            statusText.text(nights > 0 ? nights + " " + ((nights == 1) ? hoverTextSingle : hoverTextMultiple) : getPromptText(bis));
        };
        picker.addEventListener("mouseover", showNightsHint);
        picker.addEventListener("focusin", showNightsHint);

        const bindOpenTrigger = function (input) {
            input.off(`.${eventNamespace}`);

            input.on(`click.${eventNamespace}`, function (e) {
                e.stopPropagation();
                openDatePicker(input);
            });

            input.on(`keydown.${eventNamespace}`, function (e) {
                if (e.key === "Enter" || e.key === " " || e.key === "ArrowDown") {
                    e.preventDefault();
                    openDatePicker(input);
                }
            });
        };

        closeButton.add(saveButton).on("click", function () {
            closeDatePicker(true);
        });

        if (!isMobileLayer) {
            calendarContainer.on("focusout", function (e) {
                // relatedTarget is null for clicks on non-focusable areas, those are handled by the outside-click handler
                if (!!e.relatedTarget && !$this[0].contains(e.relatedTarget)) {
                    closeDatePicker(false);
                }
            });
        }

        $(document).off(`.${eventNamespace}`);
        $(document).on(`keydown.${eventNamespace}`, function (e) {
            if (e.key === "Escape" && calendarContainer.hasClass("open")) {
                e.preventDefault();
                closeDatePicker(true);
            }
        });
        $(document).on(`click.${eventNamespace}`, function (e) {
            if (!calendarContainer.hasClass("open")) return;
            if ($(e.target).closest($this).length > 0 || $(e.target).closest(calendarContainer).length > 0) return;
            closeDatePicker(false);
        });

        // without the web component the inputs stay editable as fallback
        window.customElements.whenDefined(PICKER_TAG).then(function () {
            picker.labels = getPickerLabels(language);
            // min-date only blocks selecting, the keyboard navigation of the component skips disableDate() dates only
            picker.disableDate = (date) => moment(date).isBefore(earliestStartDate, "day");
            von.prop("readonly", true);
            bis.prop("readonly", true);
            bindOpenTrigger(von);
            bindOpenTrigger(bis);
        });

        buttonClearDates.on("click", function () {
            von.val("");
            bis.val("");
            pendingStart = null;
            startPicked = false;
            // setting the property before the element is upgraded would shadow the component's setter
            if (window.customElements.get(PICKER_TAG)) {
                picker.value = undefined;
            }
            showOrHideClearDates();
        });

        showOrHideClearDates();

        // disabling the dates via "no date" checkboxes is done by 18disabler.js (data-to-disable)
        $this.data("exposed", {
            activate() {
                if (isInitiallyDisabled) {
                    von.attr("name", nameVon);
                    bis.attr("name", nameBis);
                    isInitiallyDisabled = false;
                }
            }
        });
    };

    $(".calendar").each(function () {
        window.pixelpoint.ppComponents.calendar($(this));
    });
});
